import { UserDataFragment } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { Modal, SelectMenu } from "@bonliva-crm/ui";
import { Box } from "@material-ui/core";
import { useState } from "react";
import { UserSearchSingle } from "./user-search-single";

type Props = {
  value: UserDataFragment | null;
  onChange: (user: UserDataFragment | null) => void;
  label?: string;
};

export function UserSearchSingleModal(props: Props) {
  const [showUserSearch, setShowUserSearch] = useState(false);

  return (
    <Box style={{ position: "relative" }}>
      <SelectMenu
        open={showUserSearch}
        setOpen={setShowUserSearch}
        label={props.label}
        value={props.value ? props.value.Name : ""}
      />

      <Modal
        label={`${locale.Search} ${locale.User.toLowerCase()}`}
        modalContent={<UserSearchSingle value={props.value} onChange={props.onChange} />}
        open={showUserSearch}
        setOpen={setShowUserSearch}
        dimensions={{ height: "750px", minWidth: "500px", maxWidth: "50%" }}
      />
    </Box>
  );
}
